<fui-rows [formGroup]="editService.formGroup">
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <fui-append-field>
                    <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name"></wbo-text-edit-control>
                    <wbo-entity-discontinued-edit-control formControlName="discontinued"
                                                          [(ngModel)]="model.data.discontinued"></wbo-entity-discontinued-edit-control>
                </fui-append-field>
            </fui-column>
            <fui-column>
                <fui-append-field>
                    <wbo-single-select-edit-control (onSelect)="onChangeAccountType()"
                                                    [(ngModel)]="model.data.accountingType"
                                                    [allowClearSelectionOption]="false"
                                                    [readonlyOnEdit]="true"
                                                    formControlName="accountingType">
                        <wbo-select-options>
                            <wbo-select-option [value]="AccountTypeData.DEBTOR"
                                               label="wbo.account-type.edit.option.debtor">
                            </wbo-select-option>
                            <wbo-select-option [value]="AccountTypeData.EXPENSE"
                                               label="wbo.account-type.edit.option.expense">
                            </wbo-select-option>
                            <wbo-select-option [value]="AccountTypeData.OUTGOINGS"
                                               label="wbo.account-type.edit.option.outgoings">
                            </wbo-select-option>
                            <wbo-select-option [value]="AccountTypeData.VOUCHER"
                                               label="wbo.account-type.edit.option.voucher">
                            </wbo-select-option>
                        </wbo-select-options>
                    </wbo-single-select-edit-control>
                    <fui-tandem-field>
                        <wbo-checkbox-edit-control [(ngModel)]="model.data.splitAccountingExtract"
                                                   formControlName="splitAccountingExtract">
                        </wbo-checkbox-edit-control>
                        <wbo-checkbox-edit-control [(ngModel)]="model.data.manageIntercompanyLiability"
                                                   formControlName="manageIntercompanyLiability">
                        </wbo-checkbox-edit-control>
                    </fui-tandem-field>
                </fui-append-field>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <fui-tandem-field>
                    <wbo-checkbox-edit-control formControlName="accountLimited" [(ngModel)]="model.data.accountLimited"
                                               (valueChange)="onChangeAccountLimited()">
                    </wbo-checkbox-edit-control>
                    <wbo-single-select-edit-control formControlName="limitDuration"
                                                    [(ngModel)]="model.data.limitDuration"
                                                    [allowClearSelectionOption]="false"
                                                    [readonly]="isCreditLimitReadonly">
                        <wbo-select-options>
                            <wbo-select-option [value]="false"
                                               label="wbo.account-type.edit.option.limitDuration.perpetual">
                            </wbo-select-option>
                            <wbo-select-option [value]="true"
                                               label="wbo.account-type.edit.option.limitDuration.perTimePeriod"
                                               *ngIf="model.data.accountLimited">
                            </wbo-select-option>
                        </wbo-select-options>
                    </wbo-single-select-edit-control>
                </fui-tandem-field>
            </fui-column>
            <fui-column>
                <fui-append-field>
                    <wbo-numeric-edit-control formControlName="expiryPeriod"
                                              [(ngModel)]="model.data.expiryPeriod"></wbo-numeric-edit-control>
                    <wbo-single-select-edit-control formControlName="expiryPeriodUnitsDbValue"
                                                    [(ngModel)]="model.data.expiryPeriodUnitsDbValue"
                                                    [allowClearSelectionOption]="false">
                        <wbo-select-options>
                            <wbo-select-option value="HOURS" label="wbo.account-type.edit.option.hours">
                            </wbo-select-option>
                            <wbo-select-option value="DAYS" label="wbo.account-type.edit.option.days">
                            </wbo-select-option>
                            <wbo-select-option value="MONTHS" label="wbo.account-type.edit.option.months">
                            </wbo-select-option>
                        </wbo-select-options>
                    </wbo-single-select-edit-control>
                </fui-append-field>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <wbo-tax-multi-select-edit-control formControlName="applicableTaxes" [multiObjectValueType]="true"
                                                   [(ngModel)]="model.data.applicableTaxes">
                </wbo-tax-multi-select-edit-control>
            </fui-column>
            <fui-column>
                <fui-append-field>
                    <wbo-checkbox-edit-control *ngIf="isOutgoingDenominationsVisible"
                                               [(ngModel)]="model.data.outgoingDenominations"
                                               formControlName="outgoingDenominations">
                    </wbo-checkbox-edit-control>
                    <wbo-checkbox-edit-control formControlName="requiresCustomerReference"
                                               [(ngModel)]="model.data.requiresCustomerReference">
                    </wbo-checkbox-edit-control>
                </fui-append-field>
            </fui-column>
        </fui-two-columns>
    </fui-row>
</fui-rows>
